import Cookies from 'js-cookie';

/**
 * A sessão do backend V2.
 *
 * São dois tokens com papéis diferentes. O **access** é curto e viaja no header
 * `Authorization`; o **refresh** é longo, mora num cookie `httpOnly` que o
 * servidor põe em `/api/auth` e que este código nunca vê — é isso que tira a
 * sessão do alcance de um XSS. Quem renova é o servidor, em `POST /api/auth/refresh`.
 *
 * O access fica em `sessionStorage` e não em `localStorage`: sobreviver ao F5 é
 * útil, sobreviver ao fechamento da aba não é.
 */

const CHAVE = 'fishbay.v2.accessToken';

/**
 * O cookie `jwt` era a ponte com o código herdado do Strapi, que lia
 * `Cookies.get('jwt')` direto. O último leitor saiu em 13/09/2026 e o cookie
 * deixou de ser escrito; `limparSessao` ainda o apaga, para não sobrar um access
 * token velho no navegador de quem jogou antes disso.
 */
const COOKIE_PONTE_ANTIGO = 'jwt';

let emMemoria = null;

export function definirAccessToken(token) {
  emMemoria = token || null;
  if (!token) {
    limparSessao();
    return;
  }
  try {
    sessionStorage.setItem(CHAVE, token);
  } catch {
    // Aba anônima com storage bloqueado: a sessão vale só enquanto a página viver.
  }
}

export function obterAccessToken() {
  if (emMemoria) return emMemoria;
  try {
    emMemoria = sessionStorage.getItem(CHAVE);
  } catch {
    emMemoria = null;
  }
  return emMemoria;
}

export function limparSessao() {
  emMemoria = null;
  try {
    sessionStorage.removeItem(CHAVE);
  } catch {
    // Idem.
  }
  Cookies.remove(COOKIE_PONTE_ANTIGO);
}

export function temSessao() {
  return !!obterAccessToken();
}
